import { queryKeys } from 'queries/queryKeys'
import { useQueryClient } from 'react-query'
import { User } from 'types'

export const useUser = () => {
  const cache = useQueryClient()
  const data = cache?.getQueryData<User>(queryKeys.USER)
  return data
}
